<template>
  <main class="projects">
    <div class="contact lundi">
      <router-link :to="{ name: 'home' }">&larr; Back</router-link>
    </div>
    <div class="project-wrap">
      <div class="project-description">
        <div class="project-box">
          <span>Collection:</span><br>
          {{ projects.content.collection }}
        </div>
        <div class="project-box" v-html="projects.markdown.tagline_md"></div>
        <div class="project-box" v-html="projects.markdown.description_md"></div>
        <div class="project-box small" v-html="projects.markdown.credits_md"></div>
        <div class="project-box small" v-html="projects.markdown.legal_md"></div>
      </div>
      <div v-for="project in projects.children" :key="project.id" class="project">
        <gallery :project="project" />
        <h1 class="lundi">{{ project.title }}</h1>
        <div class="sizes">
          <div class="size" v-for="size in project.content.sizes" :key="size.id">
            {{ size.text }}
          </div>
        </div>
        <div class="description small" v-html="project.markdown.description_md"></div>
        <div class="buy">
          <div class="size">
            {{ project.content.price }} CHF
          </div>
          <div class="size">
            <a :href="'mailto:mail@lundipiscine.com?subject=' + project.title " target="_blank">Order</a>
          </div>
        </div>

      </div>

    </div>

  </main>
</template>

<script>
import Gallery from '@/components/Gallery.vue'
export default {
  components: {
    Gallery
  },
  computed: {
    projects() {
      return this.$store.getters.getPageByUID(this.$route.params.id)
    }
  }
}
</script>

<style lang="scss">
.project-wrap {
  padding-top:var(--lh);
  display:grid;
  grid-template-columns: repeat(8, 1fr);
  align-items: start;
  justify-content: start;
  grid-gap:var(--lh);
  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  .project {
    grid-column: span 2;
    grid-row: 1 / 2;
    border-top: 1px solid black;
    @media only screen and (max-width: 1024px) {
      grid-column: span 1;
      grid-row: span 1;
    }
    h1 {
      font-size:calc(1.5 * var(--fs));
      // margin:calc(0.5 * var(--lh)) 0;
      padding:calc(0.5 * var(--lh)) 0;
      border-top:1px solid black;
      border-bottom:1px solid black;
      text-align: center;
    }
    .colour {
      padding-bottom:calc(0.5 * var(--lh));
      text-align:center;
      width:100%;
    }
    .sizes {
      display:flex;
      justify-content: center;
      // border-top:1px solid black;
      .size {
        border-right:1px solid black;
        padding:calc(0.5 * var(--lh));
        &:last-of-type {
          border-right:0;
        }
      }
    }
    .buy {
      display:flex;
      justify-content: center;
      .size {
        border-right:1px solid black;
        padding:calc(0.5 * var(--lh));
        &:last-of-type {
          border-right:0;
        }
      }
    }
    .description {
      padding:calc(0.5 * var(--lh)) 0;
      border-top:1px solid black;
      border-bottom:1px solid black;
    }
    img {
      padding:calc(0.5 * var(--lh)) 0;
      width:100%;
      display:block;
      height:25vw;
      @media only screen and (max-width: 1024px) {
        height:45vw;
      }
      object-fit:cover;
    }
  }
  .project-description {
    grid-column: 7 / 9;
    // grid-row: span 1;
    @media only screen and (max-width: 1024px) {
      grid-column: 1 / 2;
      grid-row: span 1;
    }
    .project-box {
      padding:calc(0.5 * var(--lh)) 0;
      border-top: 1px solid black;
      &:last-of-type {
        border-bottom: 1px solid black;
      }
    }
  }
  .small {
    font-size: calc(0.6 * var(--fs));
    line-height: calc(0.6 * var(--lh));
    p {
      font-size: calc(0.6 * var(--fs));
      line-height: calc(0.6 * var(--lh));
    }
  }
}
</style>
